import React from "react";

export const CircularScoreGauge = ({ score = 0, max = 10, size = 140 }) => {
    const percentage = (score / max) * 100;
    const radius = (size - 12) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    return (
        <div
            className="relative inline-flex items-center justify-center"
            style={{ width: size, height: size }}
            data-testid="circular-score-gauge"
        >
            <svg
                width={size}
                height={size}
                className="-rotate-90"
                aria-hidden="true"
            >
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="#2A4A6B"
                    strokeWidth="8"
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="#00C853"
                    strokeWidth="8"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.8s ease" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-heading text-3xl font-bold text-white">
                    {score.toFixed(1)}
                </span>
                <span className="text-xs text-gray-400">/ {max}</span>
            </div>
        </div>
    );
};

export default CircularScoreGauge;
